import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {API_URL, QueryParam, Utils, DireccionesLocales} from "lib-base";
import {Observable} from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class DireccionLocalService {

  private baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/direcciones-locales`;
  }


  consultaDireccionesPosibles(direccionTextual: string, barrio?: string): Observable<DireccionesLocales[]> {
    const url = `${this.baseUrl}/public/consulta-direccion-posible`;
    let params: QueryParam[] = [{key: 'direccion', value: direccionTextual}];
    if (barrio && barrio !== '') {
      params.push({key: 'barrio', value: barrio})
    }
    return this.http.get<DireccionesLocales[]>(Utils.createQueryParams(url, params))
  }
}
